import React from 'react';

import {
  CmFlex,
  CmFormLabelWithQuestionIcon,
  CmText,
} from '@/components/uiParts';

type Props = {
  label: string;
  name: string;
  width?: string;
  question?: string;
};

export const CmLabelWithQuestionIconAndText: React.FC<Props> = ({
  label,
  name,
  width = '200px',
  question,
}) => {
  return (
    <CmFlex>
      <CmFormLabelWithQuestionIcon
        mb="0"
        mr="0"
        {...{ width, question }}
        fontWeight="bold"
      >
        {label}
      </CmFormLabelWithQuestionIcon>
      <CmText width={`calc(100% - ${width}px)`}>{name}</CmText>
    </CmFlex>
  );
};
